/* Built in: scroll position owns the reveal, so scrolling back restores every stage. */
(()=>{
 const clamp=v=>Math.max(0,Math.min(1,v));
 const smooth=(a,b,v)=>{const t=clamp((v-a)/(b-a));return t*t*(3-2*t);};
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const gsap=window.gsap,SplitText=window.SplitText;
 if(gsap&&SplitText)gsap.registerPlugin(SplitText);
 document.querySelectorAll('.bi-story[data-scroll-story]').forEach(section=>{
  const pin=section.querySelector('.bi-pin'),purpose=section.querySelector('.bi-layer--purpose'),family=section.querySelector('.bi-layer--family');
  const chapters=[...section.querySelectorAll('.bi-chapter')],label=section.querySelector('[data-chapter-label]'),bar=section.querySelector('.bi-progress');
  const labels=['01 / The material','02 / The purpose','03 / The everyday'];
  // The text uses the photograph's existing scroll clock. The extra .2 before
  // the pin lets the opening headline arrive while the section enters view.
  const textOffset=.2,starts=[-.18,.34,.78],exits=[.29,.73];
  let active=-1,pending=false,textTime=0,splits=[],textTimelines=[],near=false,lastValue=NaN,lastEntry=NaN;
  const setupText=()=>{
   splits.forEach(split=>split.revert());splits=[];textTimelines=[];
   if(reduced.matches||!gsap||!SplitText)return;
   chapters.forEach((chapter,index)=>{
    const heading=chapter.querySelector('h2'),body=chapter.querySelector('p');
    const readable=heading.cloneNode(true);
    readable.querySelectorAll('br').forEach(br=>br.replaceWith(' '));
    const accessibleName=readable.textContent.replace(/\s+/g,' ').trim();
    splits.push(SplitText.create(heading,{
     type:'lines',mask:'lines',linesClass:'bi-text-line',tag:'span',autoSplit:true,
     onSplit(self){
      // Preserve spaces at the authored line breaks in the accessible heading.
      heading.setAttribute('aria-label',accessibleName);
      const start=starts[index]+textOffset;
      const tl=gsap.timeline({paused:true});
      tl.set(chapter,{autoAlpha:0,y:0},0)
       .set(self.lines,{yPercent:110},0)
       .set(body,{opacity:0,y:10},0)
       .set(chapter,{autoAlpha:1},start)
       .to(self.lines,{yPercent:0,duration:.10,stagger:{amount:.016},ease:'power3.out'},start)
       .to(body,{opacity:1,y:0,duration:.07,ease:'power2.out'},start+.048);
      if(index<exits.length){
       const exit=exits[index]+textOffset;
       tl.to(self.lines,{yPercent:-110,duration:.038,stagger:{amount:.008},ease:'power2.in'},exit)
        .to(body,{opacity:0,y:-6,duration:.04,ease:'power1.in'},exit)
        .set(chapter,{autoAlpha:0},exit+.048);
      }
      textTimelines[index]=tl;
      tl.time(Math.max(.00001,textTime));
      // SplitText restores this timeline's position after font loads or reflow.
      return tl;
     }
    }));
   });
  };
  const render=(value,entry)=>{
   const p=clamp(value);section.dataset.progress=p.toFixed(4);if(bar)bar.style.setProperty('--bi-progress',p);
   textTime=p>0?p+textOffset:entry*textOffset;
   if(textTimelines.length){
    textTimelines.forEach(tl=>tl.time(Math.max(.00001,textTime)));
   }else{
    const first=smooth(.29,.39,p),last=smooth(.73,.83,p),weights=[1-first,first*(1-last),last];
    chapters.forEach((el,i)=>{const w=weights[i];el.style.opacity=w;el.style.visibility=w>.001?'visible':'hidden';el.style.transform=`translateY(${(1-w)*12}px)`;});
   }
   const next=p<.34?0:p<.78?1:2;
   if(next!==active){active=next;label.textContent=labels[next];chapters.forEach((el,i)=>el.setAttribute('aria-hidden',String(i!==next)));}
   // Enter with the board and knife already revealed, then expand immediately.
   const opening=.42+.58*smooth(0,.52,p),rise=smooth(.64,.93,p),rest=1-opening;
   purpose.style.clipPath=`inset(${17*rest}% ${25*rest}% ${17*rest}% ${55*rest}% round ${220*rest}px)`;
   family.style.clipPath=`inset(${100*(1-rise)}% 0 0 0)`;
  };
  const measure=()=>{const r=section.getBoundingClientRect();const value=reduced.matches?1:clamp(-r.top/Math.max(1,section.offsetHeight-pin.offsetHeight)),entry=clamp(1-r.top/(pin.offsetHeight*.65));if(value===lastValue&&entry===lastEntry)return;lastValue=value;lastEntry=entry;render(value,entry);};
  const requestMeasure=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;measure();});};
  const preference=()=>{section.classList.toggle('is-reduced',reduced.matches);setupText();lastValue=NaN;measure();};
  section.classList.add('is-enhanced');preference();
  new IntersectionObserver(entries=>{const now=entries[entries.length-1].isIntersecting;if(now!==near){near=now;if(near)addEventListener('scroll',requestMeasure,{passive:true});else removeEventListener('scroll',requestMeasure);}requestMeasure();},{rootMargin:'100% 0px'}).observe(section);
  addEventListener('resize',requestMeasure);addEventListener('pageshow',requestMeasure);
  new ResizeObserver(requestMeasure).observe(pin);
  reduced.addEventListener('change',preference);
 });
})();
